// Recovered compiled webpack factory 82704. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, { LogoWall: () => o });
  var n = r(95155),
    a = r(12115),
    s = r(86048);
  let i = [
    { name: "Stripe", src: "/logos/stripe.svg", className: "h-[28px] w-[67px]" },
    { name: "OpenAI", src: "/logos/openai.svg", className: "h-[26px] w-[97px]" },
    { name: "Vercel", src: "/logos/vercel.png", className: "h-[20px] w-[101px]" },
    { name: "Clerk", src: "/logos/clerk.svg", className: "h-[24px] w-[83px]" },
    { name: "SpaceXAI", src: "/logos/spacexai.svg", className: "h-[18px] w-[147px]" },
    { name: "Ultrahuman", src: "/logos/ultrahuman.png", className: "h-[14px] w-[187px]" },
    { name: "TLDR", src: "/logos/tldr.svg", className: "h-[21px] w-[72px]" },
    { name: "vidIQ", src: "/logos/vidiq.svg", className: "h-[22px] w-[67px]" },
    { name: "tuyo", src: "/logos/tuyo.svg", className: "h-[27px] w-[57px]" },
    { name: "Deblock", src: "/logos/deblock.svg", className: "h-[24px] w-[88px]" },
  ];
  function l(e) {
    let { logo: t } = e;
    return (0, n.jsx)("span", {
      role: "img",
      "aria-label": t.name,
      className: `${t.className} block max-w-full bg-[#09090b]/55 transition-colors duration-200 hover:bg-[#09090b]/80 dark:bg-white/55 dark:hover:bg-white/85`,
      style: {
        maskImage: `url(${t.src})`,
        WebkitMaskImage: `url(${t.src})`,
        maskRepeat: "no-repeat",
        WebkitMaskRepeat: "no-repeat",
        maskPosition: "center",
        WebkitMaskPosition: "center",
        maskSize: "contain",
        WebkitMaskSize: "contain",
      },
    });
  }
  function o() {
    let {
        className: e = "mt-20",
        align: t = "center",
        marquee: r = !1,
        eyebrow: o = "Loved by designers from",
      } = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
      c = (0, a.useRef)(null),
      d = (0, a.useRef)(null),
      u = (0, a.useCallback)((e) => {
        var t;
        let r = null == (t = c.current) ? void 0 : t.getAnimations()[0];
        if (!r) return;
        null !== d.current && cancelAnimationFrame(d.current);
        let n = performance.now(),
          a = (t) => {
            let s = Math.max(0, Math.min(t - n, 64));
            n = t;
            let i = r.playbackRate ?? 1,
              l = i + (e - i) * (1 - Math.pow(1 - 0.18, s / (1e3 / 60)));
            if (0.01 > Math.abs(e - l)) {
              ((r.playbackRate = e), (d.current = null));
              return;
            }
            ((r.playbackRate = l), (d.current = requestAnimationFrame(a)));
          };
        d.current = requestAnimationFrame(a);
      }, []);
    return (
      (0, a.useEffect)(
        () => () => {
          null !== d.current && cancelAnimationFrame(d.current);
        },
        [],
      ),
      (0, n.jsx)("section", {
        className: `min-w-0 ${e}`,
        children: (0, n.jsxs)("div", {
          className: `flex min-w-0 flex-col gap-6 sm:gap-9 ${"left" === t ? "items-start" : "items-center"}`,
          children: [
            (0, n.jsx)(s.Eyebrow, { children: o }),
            r
              ? (0, n.jsx)("div", {
                  className: "um-marquee w-full overflow-hidden",
                  onMouseEnter: () => u(0.25),
                  onMouseLeave: () => u(1),
                  children: (0, n.jsx)("ul", {
                    ref: c,
                    className: "um-marquee-track items-center",
                    children: [0, 1].map((e) =>
                      i.map((t) =>
                        (0, n.jsx)(
                          "li",
                          {
                            "aria-hidden": 1 === e || void 0,
                            className: "flex shrink-0 items-center pr-12 sm:pr-14",
                            children: (0, n.jsx)(l, { logo: t }),
                          },
                          `${e}-${t.name}`,
                        ),
                      ),
                    ),
                  }),
                })
              : (0, n.jsx)("ul", {
                  className: `flex flex-wrap items-center gap-x-8 gap-y-7 sm:gap-x-14 sm:gap-y-8 ${"left" === t ? "justify-start" : "justify-center"}`,
                  children: i.map((e) =>
                    (0, n.jsx)(
                      "li",
                      { className: "flex items-center", children: (0, n.jsx)(l, { logo: e }) },
                      e.name,
                    ),
                  ),
                }),
          ],
        }),
      })
    );
  }
}
